import { useEffect, useRef, useState } from "react";

const LazyImage = ({ src, alt, width = 600, height = 400 }) => {
  const imgRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const img = imgRef.current;
    if (!img) return;

    const loadImage = () => {
      if (
        img.getBoundingClientRect().top <= window.innerHeight &&
        img.getBoundingClientRect().bottom >= 0 &&
        getComputedStyle(img).display !== "none"
      ) {
        img.src = img.dataset.src;
        img.addEventListener("load", handleImageLoad);
      }
    };

    const handleImageLoad = () => {
      setIsLoaded(true); // hide loading text
      img.parentElement.classList.remove("lazy");
      img.removeEventListener("load", handleImageLoad);
    };

    const lazyLoad = () => {
      if (img.dataset.src && img.src !== img.dataset.src) {
        loadImage();
      }
    };

    // Initial load
    lazyLoad();

    // Event listeners
    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);

    return () => {
      document.removeEventListener("scroll", lazyLoad);
      window.removeEventListener("resize", lazyLoad);
      window.removeEventListener("orientationchange", lazyLoad);
    };
  }, []);

  return (
    <div
      className="lazy"
      style={{ position: "relative", width: "100%", height: "auto" }}
    >
      {!isLoaded && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f2f2f2",
            color: "#555",
            fontSize: "1rem",
          }}
        >
          Loading...
        </div>
      )}
      <img
        ref={imgRef}
        data-src={src}
        alt={alt}
        width={width}
        height={height}
        style={{ width: "100%", height: "auto", display: "block" }}
        decoding="async"
      />
    </div>
  );
};

export default LazyImage;
